import { gql } from "@apollo/client";

export const LIST_TOTALS = gql`
  query ($companyId: ID!) {
    totalSaleDocument(filter: { companyId: $companyId }) {
      totalSaleDocuments
      totalReturns
      totalValue
      totalReturnsN1
      totalSaleDocumentsN1
      totalValueN1
      percentage
      totalValueDefaultCurrency
    }
    totalPayments(filter: { companyId: $companyId }) {
      totalDocuments
      totalValue
      totalDocumentsN1
      totalValueN1
      percentage
      totalValueDefaultCurrency
    }
    totalBudgetNotSaleDocument(filter: { companyId: $companyId }) {
      totalDocuments
      totalValue
      totalValueDefaultCurrency
    }
    totalPaymentWaiting(filter: { companyId: $companyId }) {
      totalReturns
      totalValue
      totalSaleDocuments
      totalValueDefaultCurrency
    }
  }
`;

export const LIST_TOP_CLIENTS = gql`
  query listTopClients($filter: TopClientsFilter!) {
    listTopClients(filter: $filter) {
      client {
        code
        email
        id
        name
      }
      totalValue
      totalValueDefaultCurrency
    }
  }
`;

export const LIST_USER_SELLS = gql`
  query listUserSells($filter: UserSellsFilter!) {
    listUserSells(filter: $filter) {
      totalBilled
      totalBudgeted
      user {
        email
        id
        firstName
        lastName
      }
      totalBilledDefaultCurrency
      totalBudgetedDefaultCurrency
    }
  }
`;

export const LIST_TOP_SELL_PRODUCTS = gql`
  query listTopSellProducts($filter: TopSellProductsFilter!) {
    listTopSellProducts(filter: $filter) {
      name
      reference
      totalValue
      volume
      totalValueDefaultCurrency
    }
  }
`;

export const LIST_TOP_SELL_CATEGORIES = gql`
  query listTopSellCategories($filter: TopSellCategoriesFilter!) {
    listTopSellCategories(filter: $filter) {
      volume
      totalValue
      reference
      name
      totalValueDefaultCurrency
    }
  }
`;
export const LIST_DIARY_STATS = gql`
  query listDiaryStats($filter: ListDiaryStatsFilter!) {
    listDiaryStats(filter: $filter) {
      payments {
        date
        value
        valueAccumulated
      }
      paymentWaiting {
        date
        value
        valueAccumulated
      }
      saleDocument {
        date
        value
        valueAccumulated
      }
      budgetNotSaleDocument {
        date
        value
        valueAccumulated
      }
    }
  }
`;

export const PRIORITY_TASKS = gql`
  query getPriorityTasks($companyId: ID!) {
    getPriorityTasks(companyId: $companyId) {
      invoicesOverdue {
        totalAmount
        totalDocuments
      }
      budgetsAccepted {
        totalAmount
        totalDocuments
      }
      budgetsExpired {
        totalAmount
        totalDocuments
      }
    }
  }
`;
